// eslint-disable-next-line no-restricted-imports
import FormattedMessage from 'I18n/components/FormattedMessage';
import useLocaleContext from '../../hooks/useLocaleContext';
import { jsx as _jsx } from "react/jsx-runtime";
export default function LocaleFormattedMessage({
  message
}) {
  const {
    locale
  } = useLocaleContext();
  return /*#__PURE__*/_jsx(FormattedMessage, {
    message: message,
    options: {
      locale
    }
  });
}